
export const BULK_PAYMENT_LINKS_EVENTS = {
  PAGE_VIEWED: "Bulk Payment Links Create Page Viewed",
  TEMPLATE_DOWNLOAD: "Bulk Template Downloaded",
  SHEET_UPLOAD_STARTED: "Bulk Sheet Upload Started",
  SHEET_UPLOAD_SUCCEEDED: "Bulk Sheet Upload Succeeded",
  SHEET_UPLOAD_FAILED: "Bulk Sheet Upload Failed",
  AMOUNT_SOURCE_SELECTED: "Bulk Amount Source Selected",
  FIXED_AMOUNT_SET: "Bulk Fixed Amount Set",
  PAYMENT_METHODS_MODAL_OPEN: "Bulk Payment Methods Modal Opened",
  SUBMIT_CLICKED: "Bulk Create And Share Clicked",
  PAYMENT_LINK_CREATED: "Bulk Payment Links Created",
  CREATEION_FAILED: "Bulk Payment Links Create Failed"
};

export const BULK_PAYMENT_LINKS_EVENTS_PARAMS = {
  TEMPLATE_FORMAT: "template_format",
  FILE_TYPE: "file_type",
  FILE_SIZE_KB: "file_size_kb",
  ROW_COUNT: "row_count",
  VALID_ROW_COUNT: "valid_row_count",
  INVALID_ROW_COUNT: "invalid_row_count",
  AMOUNT_SOURCE: "amount_source",
  AMOUNT_VALUE: "amount_value",
  PAYMENT_METHODS_COUNT: "payment_methods_count",
  LINKS_CREATED_COUNT: "links_created_count"
};

export const BULK_PAYMENT_LINKS_EVENTS_VALUES = {
  CSV: "csv",
  TEXT_CSV: "text/csv",
  XLSX: "xlsx",
  UPLOADED_SHEET: "uploaded_sheet",
  FIXED: "fixed_for_all",
};
